import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import { payloadList, payloadTransactions } from "../../store/admin/agents/transfers";

const getList = (data: payloadList)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.transfersHistory.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getTransactionsById = (data: payloadTransactions)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.transfersHistory.transactions.replace('{transferId}', `${data.transferId}`);

  return fetch(`${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : null}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getTransfersOptions = () => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.agents.transfersHistory.options}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(endpoint, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const downloadTransfersList = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.transfersHistory.download;

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAllTransfersList = (data: payloadList)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.transfersHistory.allList;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAllTransactionsById = (data: payloadTransactions)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.transfersHistory.allTransactions.replace('{transferId}', `${data.transferId}`);

  return fetch(`${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : null}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const downloadAllTransfersList = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.transfersHistory.allDownload;

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const transfersService = {
  getList,
  getTransactionsById,
  getTransfersOptions,
  downloadTransfersList,
  getAllTransfersList,
  getAllTransactionsById,
  downloadAllTransfersList,
};
